export default{
    setColorsState: (state, data) => {
        state.colors = data
        localStorage.setItem('colors', JSON.stringify(data))
    },
    setEssentialInfo: (state, data) => {
        state.info = data
        localStorage.setItem('info', JSON.stringify(data))
    },
    setUserInfo: (state, data) => {
        state.userInfo = data
        localStorage.setItem('userInfo', JSON.stringify(data))
    }
}
